import pageKeyNames from '@/utils/page-key-names';

export default {
	data() {
		return {
			vendor: {}
		};
	},
	computed: {
		onVendorSummaryPage() {
			return this.$route.path === '/vendors';
		},
		actions() {
			const { changedEntityId, id } = this.$route.params;
			return [
				{
					id: 1,
					action: {
						path: `/vendors/${this.vendor.id ||
							changedEntityId ||
							id}/settings`,
						activePage: pageKeyNames.VENDOR_SETTINGS
					},
					title: !this.validatePermission('vendors.update')
						? " You don't have permission to perform this action."
						: 'Select to go to vendors settings',
					iconClass: 'icon icon-document',
					label: 'Details',
					type: 'route-link',
					visible: true
				},
				{
					id: 2,
					action: this.showCustomerModal,
					title: 'Click to open Client Companies Locations Modal',
					iconClass: 'icon icon-company',
					label: 'CCL',
					type: 'anchor',
					visible: this.onVendorSummaryPage,
					disabled: !this.vendor.customersCount,
					valueBadgeCount: this.vendor.customersCount
				},
				{
					id: 3,
					action: {
						path: `/vendors/${this.vendor.id ||
							changedEntityId ||
							id}/integrations`,
						params: {
							integratorId:
								this.vendor.id || changedEntityId || id
						},
						activePage: pageKeyNames.INTEGRATION_MANAGER
					},
					title: 'Select to go to integrations',
					iconClass: 'icon icon-customer-integration',
					label: 'Integrations',
					type: 'route-link',
					visible: true,
					valueBadgeCount: this.vendor.integrationsCount
				},
				{
					id: 4,
					action: '#',
					disabled: false,
					iconClass: 'icon icon-menu',
					label: 'More',
					title: 'select to see the more actions',
					type: 'dropdown',
					visible: true,
					items: [
						{
							id: 5,
							action: {
								path: `/vendors/${this.vendor.id ||
									changedEntityId ||
									id}/history`,
								activePage: pageKeyNames.VENDORS_HISTORY
							},
							iconClass: 'icon icon-history',
							label: 'History',
							title: 'Select to go to vendors history',
							type: 'route-link',
							visible: true
						}
					]
				}
			];
		}
	}
};
